import React from 'react';
import Navbar from '../../components/Navbar';
import DICOMCreate from '../../components/DICOM/DICOMCreate';
import './DICOMCreatePage.css';

const DICOMCreatePage = () => {
  return (
    <div className="dicom-create-page">
      <Navbar />
      <div className="dicom-create-content">
        <h2>New XA DICOM</h2>
        <DICOMCreate />
      </div>
    </div>
  );
};

export default DICOMCreatePage;
